import styled from 'styled-components'

import media from '../../../utils/media'

export const ToggleBar = styled.span`
  display: block;
  width: 24px;
  height: 2px;
  background-color: ${({ theme }) => theme.color.neutral900};
  border-radius: 4px;
  transform-origin: 23.5px;
  transition: all 0.3s ease-in-out;
`

export const ToggleButton = styled.button`
  position: relative;
  z-index: 2001;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 24px;
  height: 24px;
  background-color: transparent;
  border: none;
  box-shadow: none;
  padding: 0;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &.menu-opened {
    ${ToggleBar} {
      &:first-child {
        transform: rotate(-45deg);
      }

      &:nth-child(2) {
        opacity: 0;
      }

      &:nth-child(3) {
        transform: rotate(45deg);
      }
    }
  }

  ${media.greaterThan('sm')`
    display: none;
  `}
`
